<template>
  <div class="container">
    <div class="waves-block">
      <div class="row grid-row-gap-20 waves-block_row">
        <wave-image-block
          v-for="(block_item, index) in block_list"
          class="waves-block_item col-sm-4 col-12"
          :title="block_item.title"
          :sub_title="block_item.sub_title"
          :layer_text="block_item.layer_text"
          :href="block_item.href_to"
          :priority_on_sub_title="priority_on_sub_title"
          :key="`wave-image-block_${uid}-${index}`"
        />
      </div>
    </div>
  </div>
</template>

<script>
import WaveImageBlock from "../parts/builder/WaveImageBlock.vue";
import {mapGetters} from "vuex";
let local_chunk = true
export default {
  name: "WavesBlockWithImage",
  components: {
    WaveImageBlock
  },
  props: {
    /**props**/
    priority_on_sub_title: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    blocks: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        href_to: {
          type: String,
          required: true,
          default: '',
          admin_type: 'input',
        },
        title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        sub_title: {
          type: String,
          default: '',
          admin_type: 'input',
        },
        layer_text: {
          type: String,
          default: '',
          admin_type: 'input',
        },
      }
    }
    /**props**/
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    block_list() {
      return this.blocks
    },
    uid() {
      return this._uid
    },
    chunk_blocks() {
      let chunk_size = 2
      let chunks = [[]];

      let chunk_index = 0;
      this.block_list.map(el => {
        if (chunks[chunk_index].length === chunk_size) {
          chunk_index++
          chunks[chunk_index] = []
        }
        chunks[chunk_index].push(el)
      })
      return chunks;
    },
  },
  methods: {
    mobileChunk() {
      local_chunk = !local_chunk
      return local_chunk
    }
  }
}
</script>
